import React, { useState, useEffect } from "react";
import Icon from "../graphics/Icon";
import "simplebar";
import "simplebar/dist/simplebar.css";
import styled from "styled-components";
import axios from "axios";
import StaticFAQ from "../static/StaticFAQ";

const Window = styled.div`
  position: relative;
  width: 96%;
  height: 96vh;
  margin: 2vh auto;
  background: #fff;
  border-radius: 10px;

  @media (min-width: 600px) {
    width: 80%;
    height: 80vh;
    margin: 10vh auto;
  }
  @media (min-width: 960px) {
    width: 70%;
    height: 70vh;
    margin: 15vh auto;
  }
  @media (min-width: 1280px) {
    width: 60%;
    height: 60vh;
    margin: 20vh auto;
  }
  @media (min-width: 1920px) {
    width: 50%;
    height: 50vh;
    margin: 25vh auto;
  }
`;
const CloseBtn = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  z-index: 220;

  @media (min-width: 960px) {
    right: 20px;
    top: 20px;
  }
`;
const Inner = styled.div`
  margin: 0 0 0 25px;
  height: 100%;
  color: #474747;

  @media (min-width: 600px) {
    margin: 0 0 0 25px;
  }
  @media (min-width: 960px) {
    margin: 0 0 0 55px;
  }
  h1 {
    color: "#0066ff;
  }
  h2 {
    color: " #0066ff;
  }
  h3 {
    color: #474747;
  }
  ul {
    color: #474747;
    a {
      color: #474747;
      text-decoration: underline;
    }
    li::marker {
      color: #ff9700;
    }
  }
`;
const Scroll = styled.div`
  margin-top: 50px;
  height: calc(100% - 100px);
`;
const Content = styled.div`
  padding: 0 60px 0 0;
`;
const FAQ = (props) => {
  const [dynamicFaq, setDynamicFaq] = useState(null);
  const [useStaticFaq, setUseStaticFaq] = useState(false);

  const getFaq = async () => {
    try {
      const response = await axios("/faqs");
      if (response.data && typeof response.data === "string") {
        setDynamicFaq(response.data);
      } else {
        throw new Error("No html data returned");
      }
    } catch (e) {
      setUseStaticFaq(true);
    }
  };

  useEffect(() => {
    getFaq();
  }, []);

  return (
    <Window tabindex="-1">
      <CloseBtn onClick={props.onClose}>
        <Icon name="closeBlue" />
      </CloseBtn>
      <Scroll data-simplebar>
        <Content>
          <Inner>
            {useStaticFaq ? (
              <StaticFAQ />
            ) : (
              <div dangerouslySetInnerHTML={{ __html: dynamicFaq }} />
            )}
          </Inner>
        </Content>
      </Scroll>
    </Window>
  );
};

export default FAQ;



// WEBPACK FOOTER //
// ./src/components/FAQ/index.js